import {IntermediatePart} from "../../intermediatePart";

export default class WallConfiguration extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wall_configuration';
    this.partName = 'Wall Configuration';
    this.translateId = "visualizer.bathroom.shower_tub_combo.wall_configuration";
    this.visible = true;
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.createdManually = true;
  }

  // setLayers(layout) {
  //   this.activeFeature = this.features.find((feature) => {
  //     return feature.partName === this.getParent().showerBody.activeFeature.partName  // set the same glass as Body
  //   });
  //   return super.setLayers(layout);
  // }

  handleClick() {
    super.handleClick();
    const showerTubComboParent = this.getParent().getParent();
    showerTubComboParent.setShowerTubCombo();
    showerTubComboParent.setShowerSize(this.leftShowerWallType, this.showerComboSize);
    this.featureClicked();
  }

  setZIndex() {}
}
